import React from "react";
import Portfolio from "../components/Portfolio/Portfolio";

const PortfolioPage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <div className="pt-16 sm:pt-20" />
      <Portfolio />
    </div>
  );
};

export default PortfolioPage; 